export const LABELS = {
  BREADCRUMBS: ['Profile'],
  PAGE_TITLE: ['page.profile.title', 'Profile'],
  SECTIONS_NAMES: {},
};
